import { createFeatureSelector, createSelector } from '@ngrx/store';

import { REALTIME_FEATURE_KEY, RealtimeState } from './realtime.reducer';

export const selectRealtimeState =
  createFeatureSelector<RealtimeState>(REALTIME_FEATURE_KEY);

export const selectRealtimeConnectionState = createSelector(
  selectRealtimeState,
  state => state.connectionState
);

export const selectRealtimeSocketInfo = createSelector(
  selectRealtimeState,
  state => state.socketInfo
);

export const selectConnectedDevices = createSelector(
  selectRealtimeState,
  state => state.devices
);

export const selectCurrentSocketId = createSelector(
  selectRealtimeSocketInfo,
  info => info?.socketId ?? null
);

export const selectCurrentUserId = createSelector(
  selectRealtimeSocketInfo,
  info => info?.userId ?? null
);

/**
 * Backend session id of the websocket-identified client. Authoritative
 * answer for "which session is this browser?" — used by features (e.g.
 * active-devices) that need to mark the current row in an HTTP-fetched
 * list. Returns `null` until the socket has identified.
 */
export const selectCurrentSessionId = createSelector(
  selectRealtimeSocketInfo,
  info => info?.sessionId ?? null
);

export const selectRealtimeLastError = createSelector(
  selectRealtimeState,
  state => state.lastError
);
